module.exports = __webpack_public_path__ + "static/media/m_w_hw_45.c0678a31.png";